import { ReactNode } from "react";
import WarningBanner from "@/components/WarningBanner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import MaintenanceMode from "@/components/MaintenanceMode";

// 🚧 MAINTENANCE MODE - Set to false when ready to go live
const MAINTENANCE_MODE = true;

// Bypass secret loaded from environment variable for security
const BYPASS_SECRET = import.meta.env.VITE_MAINTENANCE_BYPASS || "";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  // Auto-disable maintenance in development (Lovable preview)
  const isDevelopment = import.meta.env.DEV;
  
  // Check for bypass in URL (for production)
  const urlParams = new URLSearchParams(window.location.search);
  const bypassEnabled = urlParams.get("bypass") === BYPASS_SECRET;

  // Show maintenance page only in production without bypass
  if (MAINTENANCE_MODE && !isDevelopment && !bypassEnabled) {
    return <MaintenanceMode />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <WarningBanner />
      <Navigation />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
